/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../behaviors/keyboard-accessibility.js';
import '../../../behaviors/app-menu-access-behaviour.js';

const template = html`
		<style include="app-styles">
            .border-round-brand-color{
                border:1px solid var(--brand-color);
                border-radius :24px;
            }
            .padding-4px{
                padding: 4px;
            }
           

            @media only screen and (min-device-width : 320px) and (max-device-width : 767px){

                    .text-brand-color{

                        color:var(--primary-light-color) !important;

                    }

                    .secondary-dark-text-l,.secondary-dark-text-xxl,.secondary-dark-text-s{

                        color:var(--primary-light-color);

                    }

                    .border-round-brand-color{

                        border:1px solid var(--primary-light-color);

                    }

                }
		</style>
        
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" ></app-media-query>
        <div class$="{{_addClassBasedOnDevice(desktop)}}">
            <div tabindex="0" on-tap="_navigateToLoan" on-keydown="_navigateToLoanDDA" class="outlineOffset">
            <div hidden$="{{!desktop}}" class="text-transform-uppercase disabled-dark-color font-size-s">
                <oe-i18n-msg msgid="h_Loans"></oe-i18n-msg>
                 <div class="padding-4px"></div>
            </div>
            <template is="dom-if" if="{{loanLoader}}">
                <paper-spinner id="dashboard_user_loan_spinner" active></paper-spinner>
            </template>
            <template is="dom-if" if="{{!loanLoader}}">
                <template is="dom-if" if="{{!isMenuId}}">
                    <div hidden$={{!loansAvailable}}>
                        <template is="dom-repeat" items="{{loansAmountList}}">
                            <div id="dashboard_user_loan_amount_{{index}}">
                                <div class="outlineOffset secondary-dark-text-xxl font-weight-bold cursor-pointer" on-tap="_navigateToLoan" hidden$={{desktop}} tabindex="0">
                                    <currency-formator id="loanAmt" format-value={{item.amount}}></currency-formator> 
                                </div>
                                <div class="secondary-dark-text-l font-weight-bold cursor-pointer" on-keydown="_navigateToLoan" hidden$={{!desktop}}>
                                <currency-formator format-value={{item.amount}} tooltipnotrequired={{!item.showTooltip}} formatting-amount=true></currency-formator> 
                                </div>
                            </div>
                        </template>
                        <div class="secondary-dark-text-s" hidden$={{desktop}}>
                            <oe-i18n-msg msgid="m_DashboardMessage3"></oe-i18n-msg>
                        </div>
                        <div class="secondary-dark-text-xs" hidden$={{!desktop}}>
                            <oe-i18n-msg msgid="m_DashboardMessage3"></oe-i18n-msg>
                        </div>
                    </div>
                    <div hidden$={{loansAvailable}}>
                        <div hidden$={{desktop}}>
                            <div class="secondary-dark-text-s">
                                {{loansSuggestions.text}}
                            </div>
                            <div class="secondary-dark-text-xxl font-weight-bold">
                                {{loansSuggestions.formattedAmount}}
                            </div>
                        </div>
                        <div hidden$={{!desktop}}>
                            <div class="secondary-dark-text-l font-weight-bold">
                                {{loansSuggestions.formattedAmount}}
                            </div>
                            <div class="secondary-dark-text-xs">
                                {{loansSuggestions.text}}
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            </div>
            <template is="dom-if" if="{{!loanLoader}}">
                <template is="dom-if" if="{{!isMenuId}}">
                    <div hidden$={{loansAvailable}}>
                        <div hidden$={{desktop}} class="mdl-grid">
                            <div class="mdl-cell mdl-cell--12-col content-align-center">
                                <template is="dom-if" if={{!prospectIndicatorFlag}}>
                                    <div id="applyLoan_0" class="border-round-brand-color mdl-grid padding-t-zero padding-b-zero text-brand-color">
                                        <paper-button   on-tap="createAccountDIB">
                                            <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                        </paper-button>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div hidden$={{!desktop}}>
                            <template is="dom-if" if={{!prospectIndicatorFlag}}>
                                <div id="applyLoan_1" class="padding-4px padding-l-zero">
                                    <paper-button  on-tap="createAccountDIB" class="margin-zero border-round-brand-color padding-4px text-brand-color font-size-s">
                                        <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
            <template is="dom-if" if="{{isMenuId}}">
                <oe-i18n-msg class="font-size-m" msgid="l_PermissionErrorMessage"></oe-i18n-msg>
            </template>
        </div>`


Polymer({
    is: 'dashboard-user-loan',
    behaviors: [corpBehaviours.appMenuBehaviour, accessibilityBehaviours.commonFunctions, sbBehaviours.retailDashboardBehavior],
    _template: template,
    properties: {
        loans: {
            type: Array,
            notify: true,
            observer: '_loansListChanged'
        },
        loanLoader: {
            type: Boolean,
            value: true,
            notify: true
        },
        loansAccountSchemes: {
            type: Array,
            value: ['LAA']
        },
        loansAmountList: {
            type: Array,
            notify: true
        },
        loansAvailable: {
            type: Boolean,
            value: true,
            notify: true
        },
        loansSuggestions: {
            type: Object,
            notify: true
        },
        loansWithAllAccounts: {
            type: Array,
            notify: true
        },
        prospectIndicatorFlag: {
            type: Object,
            computed: 'computeProspectIndicator()'
        },
        menuId: {
            type: String,
            notify: true,
            value: "ORLNS"
        },
        isMenuId: {
            type: Boolean,
            notify: true
        }
    },

    attached: function () {
        this.set('isMenuId', this.validateElement(this.menuId))
    },
    computeProspectIndicator: function () {
        return clientStorage.get(storageType.session, "prospectIndicator") == "Y";
    },
    _addClassBasedOnDevice: function (desktop) {
        if (desktop)
            return "";
        return "text-align-center";
    },
    _goToSuggestion: function () {
        var url = this.loansSuggestions.url;
        window.oe_navigate_to(url, "");
    },
    _navigateToLoan: function () {
        if (this.isMenuId)
            return;
        var detailsURL = "/loanAcctLanding";
        var detailsNavigationData = { loanAccountList: this.loansWithAllAccounts };
        this.getDataForIds(this.loansWithAllAccounts, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/loanaccounts", function (list) {
            detailsNavigationData = {
                loanAccountList: list
            };
            window.oe_navigate_to(detailsURL, detailsNavigationData);
        });
    },
    _loansListChanged: function () {
        var currencyValueList = [];
        var currencyValueMap = {};
        var loansAmountList = [];
        var pageTitle = document.getElementById('page-title-label');
        if (this.loans) {
            if (this.loans.length > 0) {
                for (var i = 0; i < this.loans.length; i++) {
                    if (this.loansAccountSchemes.indexOf(this.loans[i].accountType.cmCode) > -1) {
                        var account = this.loans[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "dueAmount") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                }
                                else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                        }
                    }
                }


                for (var key in currencyValueMap) {
                    var index = currencyValueMap[key];
                    var val = currency.symbolize(key + ' ' + Math.abs(currencyValueList[index]));
          var amountValue = val.slice(2, val.length);
          amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
          var showTooltip = amountValue.length >= 4 ? true : false;
          loansAmountList.push({ "amount": val, "showTooltip": showTooltip });
                }
                this.loansAmountList = loansAmountList;
                if (this.$$("#dashboard_user_loan_spinner") != null)
                    this.$$("#dashboard_user_loan_spinner").active = false;
                this.loanLoader = false;
            }
            else if (pageTitle.appData.loansSuggestionsCallDone === undefined) {
                var self = this;
                this.loansAvailable = false;
                pageTitle.appData.loansSuggestionsCallDone = true;
                if (this.prospectIndicatorFlag) {
                    if (this.$$("#dashboard_user_loan_spinner") != null)
                        this.$$("#dashboard_user_loan_spinner").active = false;
                    this.loanLoader = false;
                    this.set('loansSuggestions', {});
                    pageTitle.appData.loansSuggestions = this.loansSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/loans";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function (event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        suggestions.formattedAmount = currency.symbolize(suggestions.currency + ' ' + suggestions.amount);
                        self.set('loansSuggestions', suggestions);
                        pageTitle.appData.loansSuggestions = self.loansSuggestions;
                    }
                    if (self.$$("#dashboard_user_loan_spinner") != null)
                        self.$$("#dashboard_user_loan_spinner").active = false;
                    self.loanLoader = false;
                });
                ajaxCall.addEventListener("error", function (e) {
                    self.serviceError(e);
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            }
            else {
                if (this.$$("#dashboard_user_loan_spinner") != null)
                    this.$$("#dashboard_user_loan_spinner").active = false;
                this.loanLoader = false;
                this.loansAvailable = false;
                if (pageTitle.appData.loansSuggestions)
                    this.set('loansSuggestions', pageTitle.appData.loansSuggestions);
            }
        }
    },
    serviceError: function () {
        // this.fire("oe-show-error","Please try after sometime. Currently we are not able to process your request due to technicle issues");
        if (this.$$("#dashboard_user_loan_spinner") != null)
            this.$$("#dashboard_user_loan_spinner").active = false;
        this.loanLoader = false;
        this.set('loansSuggestions', {});
        //TODO
        // log clientside issues 
    },
    createAccountDIB: function () {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
	var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["PersonalLoan", "HomeLoan"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=1";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
      var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
      self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    _navigateToLoanDDA(keyboardEvent) {
        if (keyboardEvent.keyCode === 13 || keyboardEvent.which === 13) {
            this._navigateToLoan(keyboardEvent);
        }
    }
});
